import { type WalletComputedCurrencyConversionRates, type WalletCurrency } from '@capsicum/common';

import { useConversionRatesQuery } from '../data-access/queries/useConversionRatesQuery';

import { useWalletFormatter } from './useWalletFormatter';

/**
 * @params 	fanTokenId
 * @returns conversion rates for the fan token
 */
export const useFanTokenConversionRates = (
	fanTokenId?: string,
	defaultCurrency?: WalletCurrency,
	altCurrency?: WalletCurrency
) => {
	const { formatPrice } = useWalletFormatter();

	const conversionRatesParams = !altCurrency?.id
		? [{ from: fanTokenId, to: defaultCurrency?.id }]
		: [
				{ from: fanTokenId, to: defaultCurrency?.id },
				{ from: fanTokenId, to: altCurrency?.id }
			];

	const conversionRatesReducer = (data?: WalletComputedCurrencyConversionRates) =>
		data?.map(conversion => {
			const isAltCurrency = conversion?.to === altCurrency?.id;
			const currency = isAltCurrency ? altCurrency : defaultCurrency;

			return {
				currency,
				formatPrice: (amount: number, priceRate?: number | string) =>
					formatPrice({ amount, currency, isAltCurrency, rate: priceRate || conversion?.rate || 0 }),
				rate: `${Number(conversion?.rate || 0).toFixed(2)}`
			};
		});

	const {
		data: conversionRates,
		error: conversionRatesError,
		isLoading: isConversionRatesLoading
	} = useConversionRatesQuery(conversionRatesParams, conversionRatesReducer);

	return {
		conversionRates,
		conversionRatesError,
		isConversionRatesLoading
	};
};
